module.exports = __webpack_public_path__ + "static/spc-badge-339368919e056b460f44c0fa5149cd96.png";